import { SxProps, Theme } from "@mui/material";
import { brandAlpha } from "../../../theme/mixins";

/**
 * The editor is drawn as one card per block of the page, in the order the page reads.
 * Flat, unlike the price list's nested cards, because the About page is flat: five
 * independent blocks rather than a tree, and indenting them would imply a containment
 * that is not there.
 */
export const editorWrapperStyles: SxProps<Theme> = {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
};

export const blockCardStyles: SxProps<Theme> = {
    p: 2.5,
    borderRadius: 3,
    border: '1px solid rgba(16,24,40,0.10)',
};

export const blockTitleStyles: SxProps<Theme> = {
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontSize: '0.72rem',
    color: 'text.secondary',
    mb: 2,
};

/** The Romanian box beside the English one, stacking on a phone. */
export const fieldPairStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 1.5,
};

export const textFieldStyles: SxProps<Theme> = {
    flex: 1,
    minWidth: 240,
};

/** A card inside a block: tinted so it reads as one item in a list the admin manages. */
export const cardRowStyles: SxProps<Theme> = {
    p: 2,
    mt: 1.5,
    borderRadius: 2,
    backgroundColor: brandAlpha('primary', 0.03),
    border: '1px solid rgba(16,24,40,0.08)',
};

export const cardHeaderStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    mb: 1.5,
};

export const cardLabelStyles: SxProps<Theme> = {
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.08em',
    fontSize: '0.72rem',
    color: 'text.secondary',
};

export const rowActionsStyles: SxProps<Theme> = {
    display: 'flex',
    alignItems: 'center',
};

/**
 * The icon picker: a wrapping row of tiles rather than a dropdown, because the thing being
 * chosen is a picture and a list of names would make the admin guess at each one.
 */
export const iconPickerStyles: SxProps<Theme> = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 0.5,
    mb: 1.5,
};

export const iconChoiceStyles = (isSelected: boolean): SxProps<Theme> => ({
    border: '1px solid',
    borderColor: isSelected ? 'primary.main' : 'rgba(16,24,40,0.12)',
    backgroundColor: isSelected ? brandAlpha('primary', 0.10) : 'transparent',
    borderRadius: 2,
    p: 0.75,
    color: isSelected ? 'primary.main' : 'text.secondary',
});

export const addButtonStyles: SxProps<Theme> = {
    mt: 1.5,
    textTransform: 'none',
    alignSelf: 'flex-start',
};

export const emptyBlockStyles: SxProps<Theme> = {
    py: 2,
    textAlign: 'center',
    color: 'text.secondary',
};
